


























import Vue from "vue";

export default Vue.extend({
  props: {
    autofocus: {
      type: Boolean,
      required: false,
      default: (): boolean => false
    },
    value: {
      type: String,
      required: false
    },
    inputmode: {
      type: String,
      required: false,
      default: (): string => "text"
    },
    pattern: {
      type: String,
      required: false,
      default: (): string => ""
    },
    label: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: (): string => "text"
    },
    autocomplete: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: (): string => ""
    },
    error: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: (): boolean => false
    },
    help: {
      type: String,
      required: false
    },
    minlength: {
      type: Number,
      required: false,
      default: (): Number => 0
    },
    emitChangeOnBlur: {
      type: Boolean,
      required: false,
      default: (): boolean => false
    },
    emitOnMount: {
      type: Boolean,
      required: false,
      default: (): boolean => true
    }
  },
  mounted() {
    if (this.emitOnMount) {
      this.$nextTick(() => this.emitChange(this.value));
    }
  },

  computed: {
    hasError(): boolean {
      return this.error?.trim().length > 0;
    },

    inputBindings(): object {
      const bindings = {
        type: this.type,
        class: this.hasError
          ? "border-red-500 bg-red-100"
          : "border-livid-500 bg-gray-100",
        name: this.name,
        required: this.required,
        autocomplete: this.autocomplete,
        minlength: this.minlength,
        autofocus: this.autofocus,
        placeholder: this.placeholder,
        ref: "input",
        pattern: null as null | string
      };

      if (this.pattern.length) {
        bindings.pattern = this.pattern;
      }

      return bindings;
    },

    inputHandlers(): object {
      if (this.emitChangeOnBlur) {
        return {
          blur: () =>
            this.emitChange((this.$refs.input as HTMLInputElement).value)
        };
      }

      return {
        keyup: this.emitChangeFromKeyboardEvent,
        change: this.emitChangeFromKeyboardEvent
      };
    }
  },

  methods: {
    emitChangeFromKeyboardEvent(event: KeyboardEvent) {
      this.emitChange((event.target as HTMLInputElement).value);
    },

    emitChange(value: string) {
      this.$emit(
        "input",
        value,
        (this.$refs.input as HTMLObjectElement).validity,
        { name: this.name }
      );
    }
  }
});
